import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'length'];

  get maxLength() {
    return this.inputTarget.maxLength;
  }

  connect() {
    this.inputTarget.addEventListener('input', this.updateLength);
    this.updateLength();
  }

  disconnect() {
    this.inputTarget.removeEventListener('input', this.updateLength);
  }

  updateLength = () => {
    this.lengthTarget.textContent = `${this.inputTarget.value.length}/${this.maxLength}`;
  };
}
